module.exports = __webpack_public_path__ + "static/media/icon-study.f8264c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mywk/icon-study.png
// module id = 2053
// module chunks = 6